<app-hero-section></app-hero-section>
    <app-features-section></app-features-section>
    
    <!-- Sección de casos de uso -->
     <app-use-cases></app-use-cases>

  <app-pricing></app-pricing>
    <app-pricing-models></app-pricing-models>
    <app-key-benefits></app-key-benefits>
    <!-- Sección de testimonios -->
    <app-testimonials></app-testimonials>
    <app-faq></app-faq>
    <app-cta></app-cta>
